import {
  DateRangeFilterPresets,
  DateRangeFilterType,
  ReportSegment,
} from '../enums/reporting';

export const DEFAULT_TIME_ZONE = 'Australia/Melbourne';

export const DEFAULT_DATE_RANGE_FILTER = {
  key: 'Orders.updatedAt',
  text: 'backOfficeSalesFeed.DateTime',
  type: DateRangeFilterType.FILTER_BY_PRESET,
  value: DateRangeFilterPresets.TODAY,
};

export const ADJUSTMENTS_DATE_RANGE_FILTER = {
  key: 'OrderAdjustments.createdAt',
  text: 'backOfficeSalesFeed.DateTime',
  type: DateRangeFilterType.FILTER_BY_PRESET,
  value: DateRangeFilterPresets.TODAY,
};

export const WALK_IN_CUSTOMER = 'Walk-in';

export const NO_DATA = 'N/A';

export const DEFAULT_SEGMENT = ReportSegment.NON_VOIDED_ORDERS;
